module.exports = __webpack_public_path__ + "img/Yahav45.960d012a.png";